'use strict';

angular.module('oddModule', []);